var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "client_name",
      "label": "客户名称"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('client_name');
      }
    },
    model: {
      value: _vm.data.client_name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "client_name", $$v);
      },
      expression: "data.client_name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "hardware_version",
      "label": "硬件版本"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('hardware_version');
      }
    },
    model: {
      value: _vm.data.hardware_version,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "hardware_version", $$v);
      },
      expression: "data.hardware_version"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "lang",
      "label": "产品语言"
    }
  }, [_c('Select', {
    model: {
      value: _vm.data.lang,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "lang", $$v);
      },
      expression: "data.lang"
    }
  }, [_c('Option', {
    attrs: {
      "value": "zh-cn"
    }
  }, [_vm._v("简体中文")]), _c('Option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")])], 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "license_interface",
      "label": "激活接口"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('license_interface');
      }
    },
    model: {
      value: _vm.data.license_interface,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "license_interface", $$v);
      },
      expression: "data.license_interface"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "licensed_months",
      "label": "有效期（月）"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('licensed_months');
      }
    },
    model: {
      value: _vm.data.licensed_months,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "licensed_months", $$v);
      },
      expression: "data.licensed_months"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "licensed_num",
      "label": "授权点数"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('licensed_num');
      }
    },
    model: {
      value: _vm.data.licensed_num,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "licensed_num", $$v);
      },
      expression: "data.licensed_num"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "media_type",
      "label": "产品介质"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('media_type');
      }
    },
    model: {
      value: _vm.data.media_type,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "media_type", $$v);
      },
      expression: "data.media_type"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "product_key",
      "label": "产品标识"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('product_key');
      }
    },
    model: {
      value: _vm.data.product_key,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product_key", $$v);
      },
      expression: "data.product_key"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "product_name",
      "label": "产品名称"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('product_name');
      }
    },
    model: {
      value: _vm.data.product_name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product_name", $$v);
      },
      expression: "data.product_name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "software_version",
      "label": "软件版本"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('software_version');
      }
    },
    model: {
      value: _vm.data.software_version,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "software_version", $$v);
      },
      expression: "data.software_version"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "mcd",
      "label": "机器码文件"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('mcd');
      }
    },
    model: {
      value: _vm.data.mcd,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "mcd", $$v);
      },
      expression: "data.mcd"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };